const API_CONFIG = {
    apiKey: `https://fashion-boutique-backend.vercel.app`,
};
  
export default API_CONFIG;

